import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
} from "alm-react-components";
import { useTranslation } from "react-i18next";
import { getCurrencySymbol } from "../../../lib/utils";
import { FreeTrialPrice } from "../../../assets/constants/constants";

const Membership = ({
  icon,
  billingType,
  trialPeriod,
  billingCycle,
}: {
  icon: any;
  billingType: any;
  trialPeriod: any;
  billingCycle: any;
}) => {
  const { t } = useTranslation();
  const trialPeriodData: any = new Date(
    Date.now() + trialPeriod * 24 * 60 * 60 * 1000
  ).toLocaleDateString();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="outline"
          className="text-base font-normal px-4 py-2 h-auto border-lime-600 text-center items-center mx-auto"
        >
          <span
            dangerouslySetInnerHTML={{
              __html: `${t("MembershipModal.startYour")} ${billingCycle[0]?.trialPeriodDays
                } ${t("MembershipModal.daysTrial")}`,
            }}
          />
         {icon}

        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent className="bg-fillMidGrayCard border-0 py-6 px-6">
        <div className="flex justify-end">
          <AlertDialogCancel className="border-none w-fit bg-transparent font-opensansSemiBold absolute right-3 top-4">
            X
          </AlertDialogCancel>
        </div>
        <AlertDialogHeader>
          <AlertDialogTitle
            className="text-center text-left text-3xl mb-5 font-barlowMedium tracking-wide yellow"
            dangerouslySetInnerHTML={{
              __html: `${getCurrencySymbol(
                billingType.currency
              )} ${FreeTrialPrice.toFixed(2)} ${t("MembershipModal.dueNow")}`,
            }}
          ></AlertDialogTitle>

          <AlertDialogDescription className="text-start">
            <p
              className="text-white text-2xl mb-4 font-medium font-barlowRegular tracking-wide"
              dangerouslySetInnerHTML={{
                __html: t("MembershipModal.paymentEnd"),
              }}
            ></p>

            <p className="text-white text-base py-5 mb-3 font-opensansLight tracking-wide">
              {(t("BillingCycle.cancelBefore"))} {trialPeriodData} {(t("BillingCycle.youWontCharge"))}
            </p>
            {/*<b>{programName}</b>*/}
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default Membership;
